import { h } from 'preact';

import './Toast.scoped.scss';

const Toast = props => (
  <div class="toast" {...props} />
);

export default Toast;